// Ported from vlookup-dramatic/components/store-badges.tsx by scripts/revamp/port-design.js
import React from "react";
import Link from "./link";
import Image from "./image";
import { appStoreUrl, playStoreUrl } from "../lib/content";
import { cn } from "../lib/utils";
// Polished, official-looking App Store / Google Play badges + app QR codes.
// Dark badges read well on both the faithful (black) and dramatic (navy) app sections.
export function AppStoreBadge({ href = appStoreUrl, className, }) {
    return (<Link href={href} target="_blank" rel="noopener noreferrer" aria-label="Download vLookUp Mentoring on the App Store" className={cn("inline-flex items-center gap-2.5 rounded-xl bg-black px-4 py-2.5 ring-1 ring-white/20 transition-transform hover:scale-[1.03]", className)}>
      <svg viewBox="0 0 24 24" aria-hidden className="size-7 shrink-0 fill-white">
        <path d="M17.543 12.213c-.02-2.09 1.706-3.093 1.784-3.14-.973-1.423-2.487-1.618-3.023-1.638-1.287-.13-2.512.757-3.163.757-.65 0-1.657-.738-2.724-.717-1.401.02-2.693.813-3.414 2.067-1.454 2.522-.372 6.256 1.043 8.306.69 1.004 1.514 2.132 2.594 2.092 1.04-.042 1.433-.672 2.69-.672 1.257 0 1.61.672 2.71.652 1.118-.02 1.826-1.024 2.51-2.03.79-1.164 1.115-2.29 1.135-2.348-.025-.012-2.178-.836-2.198-3.315M15.29 6.29c.574-.696.96-1.664.855-2.628-.826.033-1.827.55-2.42 1.246-.532.617-.998 1.602-.873 2.548.922.071 1.864-.469 2.438-1.166"/>
      </svg>
      <span className="flex flex-col gap-[3px] leading-none">
        <span className="text-[10px] font-medium tracking-wide text-white/80">
          Download on the
        </span>
        <span className="text-[17px] font-semibold leading-[1.1] text-white">
          App Store
        </span>
      </span>
    </Link>);
}
export function GooglePlayBadge({ href = playStoreUrl, className, }) {
    return (<Link href={href} target="_blank" rel="noopener noreferrer" aria-label="Get vLookUp on Google Play" className={cn("inline-flex items-center gap-2.5 rounded-xl bg-black px-4 py-2.5 ring-1 ring-white/20 transition-transform hover:scale-[1.03]", className)}>
      <svg viewBox="0 0 24 24" aria-hidden className="size-6 shrink-0">
        <path fill="#00d1ff" d="M3.6 1.8c-.3.2-.5.6-.5 1.1v18.2c0 .5.2.9.5 1.1l.1.1L13.3 12.1v-.2L3.7 1.7z"/>
        <path fill="#ffce00" d="M16.6 15.4l-3.3-3.3v-.2l3.3-3.3.1 0 3.9 2.2c1.1.6 1.1 1.6 0 2.3l-3.9 2.1z"/>
        <path fill="#ff3d47" d="M16.7 15.3 13.3 12 3.6 22.4c.4.4 1 .4 1.6.1l11.5-6.6z"/>
        <path fill="#00e676" d="M16.7 8.7 5.2 1.5c-.6-.3-1.2-.3-1.6.1L13.3 12z"/>
      </svg>
      <span className="flex flex-col gap-[3px] leading-none">
        <span className="text-[10px] font-medium tracking-wide text-white/80">
          GET IT ON
        </span>
        <span className="text-[17px] font-semibold leading-[1.1] text-white">
          Google Play
        </span>
      </span>
    </Link>);
}
// Two app QR codes (real, scannable — they encode appStoreUrl / playStoreUrl).
// `size` keeps them a supporting detail rather than the loudest thing on the
// panel: 64px reads as a scan target without competing with the store badges.
export function AppQrCodes({ size = 64, className, labelClassName, }) {
    const codes = [
        { src: "/revamp/images/qr-ios.png", label: "iOS", href: appStoreUrl },
        { src: "/revamp/images/qr-android.png", label: "Android", href: playStoreUrl },
    ];
    return (<div className={cn("flex items-center gap-3", className)}>
      {codes.map((c) => (<Link key={c.label} href={c.href} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 rounded-2xl bg-card p-2 ring-1 ring-brand-navy/10 transition-shadow hover:shadow-md">
          <Image src={c.src} alt={`${c.label} app download QR code`} width={size} height={size} style={{ width: size, height: size }} className="rounded-lg"/>
          {/* fixed width so both tiles line up regardless of label length */}
          <span className={cn("w-[52px] pr-1 text-[11.5px] font-semibold", labelClassName)}>
            {c.label}
          </span>
        </Link>))}
    </div>);
}
